/*********************** Custom JS for Boost AI Search & Discovery  ************************/
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
        componentRegistry.useComponentPlugin('ProductPrice', {
            name: 'ProductPrice component',
            enabled: true,
            apply: () => ({
                props(props, element) {
                    console.log(props);
                    return props;
                },
                // afterRender(element) {
                //     try {
                //         const swatchOption = element?.getParams()?.props;
                //         const productData =
                //             componentRegistry.getNearestParentElm(element, 'ProductItemWidget')?.getParams()?.props?.product ||
                //             componentRegistry.getNearestParentElm(element, 'QuickView')?.getParams()?.props?.productData;

                //         if (swatchOption && productData) {
                //             const productVariants = productData.variants || [];
                //             let swatchStatus = checkOptionStatus(productVariants, swatchOption.value);
                //             if (!swatchStatus) {
                //                 const swatchElm = document.querySelector(`label[for*="${swatchOption.id}"]`);
                //                 const swatchInput = document.querySelector(`input[id*="${swatchOption.id}"]`);
                //                 if (swatchElm && swatchElm.closest('.boost-sd__product-swatch-option')) {
                //                     swatchElm.closest('.boost-sd__product-swatch-option').classList.add('boost-sd__sold-out');
                //                     swatchElm.classList.remove('boost-sd__radio-label--selected');
                //                 }
                //                 if (swatchInput) {
                //                     swatchInput.removeAttribute('checked');
                //                 }

                //                 const swatchButton = swatchElm.closest('.boost-sd__quick-view');
                //                 if (swatchButton && !swatchButton.querySelector('.BIS_trigger')) {
                //                     const bisHtml = "<a href='#' class='BIS_trigger' data-product-handle='" + productData.handle + "' data-product-data='" + JSON.stringify(productData) + "'>NOTIFY ME WHEN AVAILABLE</a>";
                //                     swatchButton.insertAdjacentHTML('beforeend', bisHtml);
                //                     if (isMobileDevice()) {
                //                         swatchButton.querySelector('.boost-sd__quick-view-btn').style.display = 'none';
                //                     } else {
                //                         swatchButton.querySelector('.boost-sd__button').style.display = 'none';
                //                     }
                //                 }
                //             } else {
                //                 const swatchButton = swatchElm.closest('.boost-sd__quick-view');
                //                 if (swatchButton && swatchButton.querySelector('.BIS_trigger')) {
                //                     if (isMobileDevice()) {
                //                         swatchButton.querySelector('.boost-sd__quick-view-btn').style.display = 'block';
                //                     } else {
                //                         swatchButton.querySelector('.boost-sd__button').style.display = 'block';
                //                     }
                //                     swatchButton.querySelector('.BIS_trigger').style.display = 'none';
                //                 }
                //             }
                //         }
                //     } catch (error) {
                //         console.warn(error);
                //     }
                // },
            }),
        });
    }
]);